import { Box, CardActionArea, Tooltip } from "@mui/material";
import { CheckCircle, Warning } from "@mui/icons-material";
import { displayDateAndTimeString, displayMillisecondsAsSeconds } from "Backend";
import theme from "theme";
import { AiChatType, AiChatView } from "generated/graphql";
import CopyToClipboard from "components/CopyToClipboard";
import { useAppSelector } from "redux/hooks";
import { selectLensEditorFormFields } from "redux/slices/lensEditor";
import { useMemo } from "react";
interface AiChatPreviewProps {
  chat: AiChatView;
  selected: boolean;
  onClick: () => void;
}
export const AiChatPreview = ({ chat, selected, onClick }: AiChatPreviewProps) => {
  const formFields = useAppSelector(selectLensEditorFormFields);
  const field = formFields.find((f) => f.id === chat.fieldId);
  const actionAreaSx = useMemo(() => {
    return {
      borderColor: selected ? theme.palette.primary.main : theme.palette.grey[50],
      borderWidth: 1,
      borderStyle: "solid",
      borderRadius: 1,
    };
  }, [selected]);
  return (
    <CardActionArea id={chat.id} sx={actionAreaSx} onClick={onClick}>
      <div className="p-1">
        <div>
          <div className="flex flex-row justify-between items-start">
            <div className="flex flex-column">
              <div className="flex">
                <p className="text-xxs font-bold">{chat.clientCaseId}</p>
                <CopyToClipboard
                  title="Copy Case ID"
                  text={chat.clientCaseId}
                  sx={{ width: 14, height: 14, mr: 0.5 }}
                />
                {field && (
                  <p className="text-xxs font-bold">
                    {field.outlinePrefix} {field.name}
                  </p>
                )}
              </div>
              {chat.chatType !== AiChatType.ProfilePrediction && <p className="text-xxs">{chat.chatType}</p>}
            </div>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}>
              <Tooltip arrow title={chat.failureReason || "success"} placement="bottom">
                {chat.failureReason ? (
                  <Warning fontSize="small" color="error" />
                ) : (
                  <CheckCircle fontSize="small" color="success" />
                )}
              </Tooltip>
            </Box>
          </div>
          <div className="flex flex-row gap-1 mb-1 mt-0.5">
            <p className="text-xxs">{displayMillisecondsAsSeconds(chat.modelTimeMs ?? 0)}</p>
            <p className="text-xxs">{displayDateAndTimeString(chat.createdAt)}</p>
          </div>
        </div>
        <div className="flex flex-row">
          <p className="text-xxs font-mono">{chat.id}</p>
          <CopyToClipboard title="Copy Chat ID" text={chat.id} sx={{ width: 14, height: 14, mr: 0.5 }} />
        </div>
      </div>
    </CardActionArea>
  );
};

export default AiChatPreview;
